import { MatDialogConfig } from '@angular/material/dialog';

export const defaultDialogConfig: MatDialogConfig = {
  width: '30rem',
  panelClass: 'base-dialog',
  autoFocus: false
};
